import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectIsAdminNotSuperUser, selectIsSuperUserNotMatrixPPAAdmin, selectUserOrgId } from '@store/selectors/user/user.selectors';
import * as fromUserAdmin from '@store/reducers/user-admin/user-admin.reducer';
import { RoleConstants, ROLE_GROUPS } from '../../../constants/roles';

export const selectUserAdminState = createFeatureSelector<fromUserAdmin.State>(
  fromUserAdmin.userAdminFeatureKey
);

export const selectUsers = createSelector(
    selectUserAdminState,
    (state: fromUserAdmin.State) => {
        return state.users;
    }
);

export const selectOrgFilterSearch = createSelector(
    selectUserAdminState,
    (state: fromUserAdmin.State) => {
        return state.orgSearch;
    }
);

export const selectOrgs = createSelector(
    selectUserAdminState,
    (state: fromUserAdmin.State) => {
        return state.organizationDropdown;
    }
);

export const selectRoleFilterSearch = createSelector(
    selectUserAdminState,
    (state: fromUserAdmin.State) => {
        return state.roleSearch;
    }
);

export const selectUserInfo = createSelector(
    selectUserAdminState,
    (state: fromUserAdmin.State) => ({
      itemsPerPage: state.itemsPerPage,
      itemsPerPageList: [5, 10, 25, 100],
      totalItems: state.totalItems,
    })
);

export const selectIsLoading = createSelector(
    selectUserAdminState,
    (state: fromUserAdmin.State) => {
        return state.isLoading;
    }
);

export const selectUserRoles = createSelector(
    selectUserAdminState,
    (state: fromUserAdmin.State) => {
        return state.roleDropdown;
    }
);

export const selectUserAdminFilteredRoles = createSelector(
    selectUserAdminState,
    (state: fromUserAdmin.State) => {
        return state.roleDropdown.filter((search) => {
            return search.name.toLowerCase().includes(state.roleSearch.toLowerCase());
        });
    }
);

export const selectUserAdminFilteredOrgs = createSelector(
    selectUserAdminState,
    (state: fromUserAdmin.State) => {
        return state.organizationDropdown.filter((search) => {
            return search.name.toLowerCase().includes(state.orgSearch.toLowerCase());

        });
    }
);

export const selectUserAdminFilteredRolesWithRole = createSelector(
    selectUserAdminState,
    selectIsAdminNotSuperUser,
    selectIsSuperUserNotMatrixPPAAdmin,
    (state: fromUserAdmin.State, isAdminNotSuper, isSuperUserNotMatrixPPAAdmin) => {
        return state.roleDropdown.filter((role) => {
            let filter = role.name.toLowerCase().includes(state.roleSearch.toLowerCase());
            if (isAdminNotSuper) {
                filter = filter && !ROLE_GROUPS.SUPER_USER.includes(role.id.toString());
            }
            if (isSuperUserNotMatrixPPAAdmin) {
                filter = filter && role.id.toString() !== RoleConstants.MATRIX_PPA_ADMIN;
            }
            return filter;
        });
    }
);

export const selectUserAdminFilteredOrgsWithRole = createSelector(
    selectUserAdminState,
    selectUserOrgId,
    selectIsAdminNotSuperUser,
    (state: fromUserAdmin.State, orgId, isAdminNotSuper) => {
        return state.organizationDropdown.filter((org) => {
            let filter = org.name.toLowerCase().includes(state.orgSearch.toLowerCase());
            if (isAdminNotSuper) {
                filter = filter && parseInt(org.id) == orgId;
            }
            return filter;
        });
    }
);

export const selectIsSaveDisabled = createSelector(
    selectUserAdminState,
    (state: fromUserAdmin.State) => {
        return state.isSaveDisabled;
    }
);

export const selectOriginalEmail = createSelector(
    selectUserAdminState,
    (state: fromUserAdmin.State) => {
        return state.originalEmail;
    }
);

export const selectUserAdminForm = createSelector(
    selectUserAdminState,
    (state: fromUserAdmin.State) => ({
        userSearch: state.userSearch
    })
);
